module.exports = __webpack_public_path__ + "static/media/14321640762972shutterstock_383952502-1.c91beb6f.jpg";